import { cn } from '@/lib/utils';

interface DropOverlayProps {
  /** Show the highlight — wire this to `useImageDropPaste().isDragging`. */
  active: boolean;
  /** Overlay caption. Pass `null` on small targets (avatars, icon buttons) to show only the ring. */
  label?: string | null;
  /** Rounding to match the target; defaults to `rounded-lg`. */
  className?: string;
}

/**
 * The "drop to attach" highlight shown while an image is dragged over a target,
 * consistent with the service Attachments panel. Render inside a `relative`
 * container alongside the element receiving `useImageDropPaste().dropZoneProps`.
 */
export function DropOverlay({ active, label = 'Drop to attach', className }: DropOverlayProps) {
  if (!active) return null;
  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-green-50/80 ring-2 ring-green-400',
        className,
      )}
    >
      {label && (
        <span className="rounded-md bg-white/90 px-2 py-1 text-xs font-medium text-green-700 shadow-sm">
          {label}
        </span>
      )}
    </div>
  );
}
